export default function installPlugins(app){}